import React from "react";

import cn from "classnames";
import { IntlShape } from "react-intl";

import { ModalFunctions } from "@mapmycustomers/ui";

import { formatEmailLink } from "../formatters";

import { EMAIL_WARNING_MODAL_CLASS_NAME } from "./const";
import styles from "./sendEmailViaClient.module.scss";

const sendEmailViaClient = (
  email: string,
  intl: IntlShape,
  entityName: string,
  modal?: Omit<ModalFunctions, "warn">,
  onTrackActivity?: () => void
) => {
  window.open(formatEmailLink(email) ?? undefined, "_blank");
  if (modal && onTrackActivity) {
    modal.show({
      cancelText: intl.formatMessage({
        id: "utils.email.sendEmailViaClient.confirmation.cancelText",
        defaultMessage: "No thanks",
        description: "Text for the confirmation modal's 'Don't log' button",
      }),
      centered: true,
      className: cn(styles.container, EMAIL_WARNING_MODAL_CLASS_NAME),
      content: (
        <div>
          {intl.formatMessage({
            id: "utils.email.sendEmailViaClient.confirmation.content",
            defaultMessage:
              "We recommend logging an email activity to more accurately track interactions with this account.",
            description: "Content for the confirmation modal after sending an email",
          })}
        </div>
      ),
      okText: intl.formatMessage({
        id: "utils.email.sendEmailViaClient.confirmation.okText",
        defaultMessage: "Yes, log email",
        description: "Text for the confirmation modal's 'Log email' button",
      }),
      onOk: onTrackActivity,
      title: intl.formatMessage(
        {
          id: "utils.email.sendEmailViaClient.confirmation.title",
          defaultMessage: "Log email with {entityName}?",
          description: "Title for the confirmation modal after sending an email",
        },
        { entityName }
      ),
      type: "confirm",
    });
  }
};

export default sendEmailViaClient;
